import { createAsyncTypes } from 'utils/ActionCreator'

export const DATA_REQUEST_ASYNC = createAsyncTypes(
  'DATA_REQUEST',
  'Mailboxes/Management/VipDiscovery'
)
export const UPDATE_DATA_REQUEST_ASYNC = createAsyncTypes(
  'UPDATE_DATA_REQUEST',
  'Mailboxes/Management/VipDiscovery'
)
export const SELECT_TOGGLE = 'Mailboxes/Management/VipDiscovery/SELECT_TOGGLE'
